"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
var _Segment = _interopRequireDefault(require("./Segment"));
exports.default = _Segment.default;